import { EmptyState, Stack } from '@all-manager/design-system-v2';
import { ComponentProps } from "react";
import { ReminderDatabase } from "../../../../types";
import ReminderCard from "../../../providers/components/ProviderDetails/ReminderCard/ReminderCard";
import NoRemindersIcon from "../../assets/no-reminders.svg?react";

type Props = {
  reminders: ReminderDatabase[];
} & Pick<ComponentProps<typeof ReminderCard>, 'displayProvider' | 'displaySubject'>

export default function ProviderRemindersList(props: Props) {
  if (props.reminders.length === 0) {
    return (
      <EmptyState
        title="Aucun rappel"
        subtitle="Enregistrez vos premiers rappels pour ne rien oublier."
        image={<NoRemindersIcon />}
      />
    );
  }

  return (
    <Stack spacing={1}>
      {props.reminders.map((reminder) => (
        <ReminderCard
          key={reminder.id}
          reminder={reminder}
          displayProvider={props.displayProvider}
          displaySubject={props.displaySubject}
        />
      ))}
    </Stack>
  );
}
